import { Path, Svg } from "@react-pdf/renderer";

export const PDFCrossSvg = () => {
  return (
    <Svg width="10" height="10" viewBox="0 0 19 19">
      <Path d="M3 3l13 13M16 3L3 16" stroke="#EB5757" strokeWidth="2" />
    </Svg>
  );
};
